import { Link } from '@atoms'
import EmptyState from '@components/molecules/EmptyState'
import { scopedTranslation } from '@utils/I18n'

import type { BlastChannel } from '../../types'

const t = scopedTranslation('comms_management.blasts_index.empty')

const channelIcon = { email: 'mail-01', sms: 'message-chat-square' } as const

export function BlastsEmptyState({
  channel,
  hasFilters,
  newBlastPath,
  className,
}: {
  channel: BlastChannel
  hasFilters: boolean
  newBlastPath: string
  className?: string
}) {
  if (hasFilters) {
    return (
      <div role="status">
        <EmptyState
          className={className}
          iconType="search-lg"
          headline={t(`no_matches.${channel}.headline`)}
          subtext={t(`no_matches.${channel}.subtext`)}
        />
      </div>
    )
  }

  return (
    <EmptyState
      className={className}
      iconType={channelIcon[channel]}
      headline={t(`no_blasts.${channel}.headline`)}
      subtext={t(`no_blasts.${channel}.subtext`)}
    >
      <Link href={newBlastPath} rank="primary" trailingIcon="plus-circle">
        {t(`no_blasts.button.${channel}`)}
      </Link>
    </EmptyState>
  )
}
